import React, {useState, useEffect, useContext} from 'react';
import { useQuery, useMutation, useApolloClient } from '@apollo/client';
import { getGroupIdOfTenantQuery, getComponentsDetailsOfDartQuery, insertValueOfComponentQuery, updateValueOfComponentQuery, updateAutomationStautsQuery, deleteValueOfComponentQuery, updateCollectionStauts } from "../../../graphql/remediations_queries"
import { GlobalContext } from "../../../hooks/globalContext";
import { useNavigate } from "react-router-dom";
import { log } from 'console';
import { getAppMonitored } from '../../../graphql/app_monitored_queries';
import { getAutomationListsQuery } from '../../../graphql/configuration_queries';

type dataProps = {
    data?: any;
    func?: any;
    searchVal?: String;
    pageNo?: any;
    setTotalPages?: any;
    setTotalRecords?: any;
    setDartSpecs?: any;
    setJsonData?: any;
    setUiData?: any;
    deleteAutomation?: any;
    setDeleteAutomation?: any;
    setDeleteDisabled?: any;
    isRefresh?: any;
    setRefresh?: any;
    setSaveBtnClicked?:any
}

const Conditional_Accesses_Attach_func = (props: any) => {
    const client = useApolloClient();

    const contextValue: any = useContext(GlobalContext);
    var selctedValue: any = '';
    var dartNo: any = contextValue.dartNo;
    var tenantName = contextValue.tenantName;
    var automationID = contextValue.automationDetails.automationID;
    var insertCounter = 0;
    var totalGrpDataCnt = 0;
    var failedAttachmentGroups: any = [];
    var failedDetachmentGroups: any = [];
    var mcatuniq = '';
    var collectionData = {
        id: '',
        status: ''
    };

    var conditionalAccessConfigData: any = {};

    //to check site/group is configured or not
    const getGroupIdOfTenant = async (whereCondition: any, action: any) => {
        insertCounter = 0;
        try {
            const { data, loading, error } = await client.query({
                query: getGroupIdOfTenantQuery,
                variables: { whereCondition },
                fetchPolicy: 'network-only',
            });
    
            if(!loading && data){
                totalGrpDataCnt = data.core_MachineGroups.length;
                // var selectedapp: any = localStorage.getItem('selectedapp');
                // selectedapp = JSON.parse(selectedapp);
                // var id = selectedapp.rowid;

                data.core_MachineGroups.map(async (val: any) => {
                    insertCounter++;
                    mcatuniq = val.mcatuniq;
                    
                    await getComponentsDetailsOfDart([dartNo], val.mgroupuniq, val.name);
                    // await getAutomationList({id: {_eq: id}}, null, null,'dataCollectionConfig');

                    if(action == 'detach'){
                        console.log("deleteing...........");

                        // setTimeout(() => {
                            removeValueInComponent(val.mgroupuniq, val.name);
                        // }, 2000);
                    } 
                    
                    if(action == 'attach'){
                        console.log("inserting...........");
        
                        // setTimeout(() => {
                            // setValueOfdataCollectionComponent(val.mgroupuniq, val.name);
                            setValueOfComponent(val.mgroupuniq, val.name);
                        // }, 2000);
                    }
                });
            }else{
                console.log("Site has not configured");

                props.userActivity('Add', `{"remediationName":"${contextValue.automationDetails.automationName}","type":"app policy","attachedGroups":"${props.groupAttachment}","detachedGroups":"${props.groupDetachment}","error":"${error}","summary":"Assignment failed"}`, 'Failure');

                props.setmessagebar1(false);
                props.setmessagebar2(true);
                props.setToastMessage("Assignment failed");
            }
        }catch(error){
            props.userActivity('Add', `{"remediationName":"${contextValue.automationDetails.automationName}","type":"app policy","attachedGroups":"${props.groupAttachment}","detachedGroups":"${props.groupDetachment}","error":"${error}","summary":"Assignment failed"}`, 'Failure');

            props.setmessagebar1(false);
            props.setmessagebar2(true);
            props.setToastMessage("Assignment failed");
        }
    }

    //to fetch the name, varnameuniq, varscopuniq, varuniq of components
    const getComponentsDetailsOfDart = async (dartId: any, groupId: any, name: String) => {
        const { data, loading, error } = await client.query({
            query: getComponentsDetailsOfDartQuery,
            variables: { dartId, groupId },
            fetchPolicy: 'network-only',
        });
  
        if(!loading && data) {
            data.core_Variables.map((val: any) => {
                if(dartJsonKeys.includes(val.name)){
                    console.log("keysss=",val.name);
                    
                    var conditionalAccessConfigIds = {
                        id : val.Variables_VarValues[0]?.valueid,
                        varuniq : val.varuniq,
                        varscopuniq : val.varscopuniq,
                        varnameuniq : val.varnameuniq,
                        componentValue : val.Variables_VarValues[0]?.valu,
                        revised : val.Variables_VarValues[0]?.revl
                    }

                    conditionalAccessConfigData[`${name}`] = {...conditionalAccessConfigData[`${name}`], [`${val.name}`]: conditionalAccessConfigIds};
                }
            });
        }
    }

    var dartJsonObj: any = {};
    var dartJsonKeys: any = [];
    const getAutomationList = async(whereCondition: any, limit: any = null, offset: any = null) => {
        const { data, loading, error } = await client.query({
          query: getAutomationListsQuery,
          variables: {whereCondition, limit, offset},
          fetchPolicy: 'network-only',
        });
    
        if(!loading && data.core_AutomationJSON.length > 0){
            data.core_AutomationJSON.map((val: any) => {
                dartJsonObj = JSON.parse(val?.jsonValue);

                collectionData.id = data.core_AutomationJSON[0].id;
                collectionData.status = data.core_AutomationJSON[0].status;
            });

            dartJsonKeys = Object.keys(dartJsonObj);
        }
    }

    const setValueOfComponent = async (mgroupuniq: any, name: String) => {  
        var status = false;
        
        await Promise.all(dartJsonKeys.map(async (compName: any, cnt: number) => {
            var componentVal = '';

            console.log("compName=",compName);
            console.log("name=",name);
            console.log("conditionalAccessConfigData=",conditionalAccessConfigData);

            if(dartJsonKeys.length === (cnt+1)){
                if(conditionalAccessConfigData[`${name}`][`${compName}`].varuniq?.length === 0 || conditionalAccessConfigData[`${name}`][`${compName}`]?.componentValue === undefined){
                    
                    componentVal = dartJsonObj[`${compName}`];
    
                    status = await insertValueOfComponent(componentVal, 0, conditionalAccessConfigData[`${name}`][`${compName}`].varnameuniq, conditionalAccessConfigData[`${name}`][`${compName}`].varscopuniq, conditionalAccessConfigData[`${name}`][`${compName}`].varuniq, mgroupuniq);
                }else{
                    var res = conditionalAccessConfigData[`${name}`][`${compName}`].componentValue;
                    var revised = conditionalAccessConfigData[`${name}`][`${compName}`].revised;

                    var newVal = res.trim();
                    newVal += `\n` + dartJsonObj[`${compName}`];

                    status = await updateValueOfComponents({mgroupuniq: {_eq: mgroupuniq}, varuniq: {_eq: conditionalAccessConfigData[`${name}`][`${compName}`].varuniq}, varscopuniq: {_eq: conditionalAccessConfigData[`${name}`][`${compName}`].varscopuniq}}, newVal, (revised + 1));
                }
            }else{
                if(conditionalAccessConfigData[`${name}`][`${compName}`].varuniq?.length === 0 || conditionalAccessConfigData[`${name}`][`${compName}`]?.componentValue === undefined){
                    
                    if(dartJsonObj[`${compName}`].includes('-')){
                        componentVal =  dartJsonObj[`${compName}`].split("-").join('\n');
                    }else{
                        componentVal = dartJsonObj[`${compName}`];
                    }
    
                    status = await insertValueOfComponent(componentVal, 0, conditionalAccessConfigData[`${name}`][`${compName}`].varnameuniq, conditionalAccessConfigData[`${name}`][`${compName}`].varscopuniq, conditionalAccessConfigData[`${name}`][`${compName}`].varuniq, mgroupuniq);
                }
            }
        }));

        console.log("status=",status, "totalGrpDataCnt=",totalGrpDataCnt, "insertCounter=",insertCounter);
        
        if(status && (totalGrpDataCnt == insertCounter)){
            insertCounter = 0;
            if(collectionData.status === null || collectionData.status === undefined){
                var collectionStatus: any = "not attached";
            }else{
                var collectionStatus: any = collectionData.status;
            }
            
            if(selctedValue == 'tenant'){
                if(collectionStatus == 'not attached'){
                    selctedValue = tenantName + ":all";
                }else if(collectionStatus?.includes(`${tenantName}:`)) {
                    if(collectionStatus.includes("|")){
                        var statusArr: any = collectionStatus.split("|");
                        statusArr = statusArr.filter((ele: any) => !ele.includes(`${tenantName}:`));
                        statusArr.push(`${tenantName}:all`);

                        selctedValue = statusArr.join("|");
                    }else{
                        selctedValue = `${tenantName}:all`;
                    }
                }else{
                    selctedValue = `${collectionStatus}|${tenantName}:all}`;
                }
            }else{
                var selectedGroups = props.groupAttachment.filter((val: any) => val != 'All Devices');
                console.log("attached selectedGroups=",selectedGroups);
                selectedGroups = selectedGroups.filter((val: any) => !(failedAttachmentGroups.includes(val)));
                console.log("filtered attached selectedGroups=",selectedGroups);

                if(collectionStatus == 'not attached'){
                    selctedValue = tenantName + ":" + selectedGroups.join(",");
                }else if(collectionStatus?.includes(`${tenantName}:`)) {
                    if(collectionStatus.includes("|")){
                        var statusArr: any = collectionStatus.split("|");
                        var curSelectedGRp = statusArr.filter((ele: any) => ele.includes(`${tenantName}:`))[0].split(":")[1];

                        console.log("attachment curSelectedGRp=",curSelectedGRp);

                        statusArr = statusArr.filter((ele: any) => !ele.includes(`${tenantName}:`));
                        statusArr.push(`${tenantName}:${curSelectedGRp},${selectedGroups.join(",")}`);
                        selctedValue = statusArr?.join("|");
                    }else{
                        var curSelectedGRp = collectionStatus.split(":")[1];

                        selctedValue = `${tenantName}:${curSelectedGRp},${selectedGroups.join(",")}`;
                    }
                }else{

                    selctedValue = `${collectionStatus}|${tenantName}:${selectedGroups.join(",")}`; 
                }
            }
            console.log("selctedValue=",selctedValue);
            
            
            await updateAutomationStauts({id: {_eq: collectionData.id}}, selctedValue, 0, 'attach');
        }
    }

    const removeValueInComponent = async (mgroupuniq: any, name: String) => {
        var status: any = false;
        var idArr: any = [];

        await Promise.all(dartJsonKeys.map(async (compName: any, cnt: number) => {
            if(dartJsonKeys.length === (cnt+1)){
                var res = conditionalAccessConfigData[`${name}`][`${compName}`].componentValue;
                var revised = conditionalAccessConfigData[`${name}`][`${compName}`].revised;

                var componentVal = res.trim();
                var componentValArr = componentVal.split('\n').filter((val: any) => val !== '');
                componentValArr.pop();

                if(componentValArr.length > 0){
                    var newVal = componentValArr.join("\n");
                    idArr = [];

                    status = await updateValueOfComponents({mgroupuniq: {_eq: mgroupuniq}, varuniq: {_eq: conditionalAccessConfigData[`${name}`][`${compName}`].varuniq}, varscopuniq: {_eq: conditionalAccessConfigData[`${name}`][`${compName}`].varscopuniq}}, newVal, (revised + 1));
                }else{
                    idArr.push(conditionalAccessConfigData[`${name}`][`${compName}`].id);
                }
            }else{
                idArr.push(conditionalAccessConfigData[`${name}`][`${compName}`].id);
            }
        }));
        
        if(idArr.length > 0){
            status = await deleteValueOfComponents(idArr);
        }

        console.log("status=",status, "totalGrpDataCnt=",totalGrpDataCnt, "insertCounter=",insertCounter);

        if(status && (totalGrpDataCnt == insertCounter)){
            insertCounter = 0;
            if(collectionData.status === null || collectionData.status === undefined){
                var collectionStatus: any = "not attached";
            }else{
                var collectionStatus: any = collectionData.status;
            }

            if(selctedValue == 'tenant'){
                if(collectionStatus != 'not attached' && collectionStatus.includes(`${tenantName}:`)) {
                    if(collectionStatus.includes("|")){
                        var statusArr: any = collectionStatus.split("|");
                        statusArr = statusArr.filter((ele: any) => !ele.includes(`${tenantName}:`));

                        selctedValue = statusArr.join("|");
                    }else{
                        selctedValue = `not attached`;
                    }
                }else{
                    selctedValue = collectionStatus;
                }
            }else{
                var selectedGroups = props.groupDetachment.filter((val: any) => val != 'All Devices');
                selectedGroups = selectedGroups.filter((val: any) => !(failedDetachmentGroups.includes(val)));

                if(collectionStatus != 'not attached' && collectionStatus.includes(`${tenantName}:`)) {
                    if(collectionStatus.includes("|")){
                        var statusArr: any = collectionStatus.split("|");
                        var curSelectedGRp = statusArr.filter((ele: any) => ele.includes(`${tenantName}:`))[0].split(":")[1].split(",");

                        curSelectedGRp = curSelectedGRp.filter((val: any) => !selectedGroups.includes(val));

                        statusArr = statusArr.filter((ele: any) => !ele.includes(`${tenantName}:`));

                        curSelectedGRp.length > 0 && statusArr.push(`${tenantName}:${curSelectedGRp.join(",")}`);
                        selctedValue = statusArr?.join("|");
                    }else{
                        var curSelectedGRp: any = collectionStatus.split(":")[1].split(",");
                        curSelectedGRp = curSelectedGRp.filter((val: any) => !selectedGroups.includes(val));

                        if(curSelectedGRp.length == 0){
                            selctedValue = 'not attached';
                        }else{
                            selctedValue = `${tenantName}:${curSelectedGRp.join(",")}`;
                        }
                    }
                }else{
                    selctedValue = collectionStatus; 
                }
            }

            let flag = props.groupAttachment?.length ? props.groupAttachment?.length : 0;
            
            await updateAutomationStauts({id: {_eq: collectionData.id}}, selctedValue, flag, 'detach');
            
            // if(props.groupAttachment.length > 0){
            //     collectionData.status = selctedValue;
            //     setTimeout(() => {
            //         attachRemediation();
            //     }, 1000);
            // }
        }
    }

    const updateAutomationStauts = async (whereCondition: any, status: any, flag: any, type: String = '') => { 
        const { data } = await client.mutate({
            mutation: updateAutomationStautsQuery,
            variables: { whereCondition, status },
            fetchPolicy: 'network-only',
        });

        if(data.update_core_AutomationJSON.affected_rows > 0){
            if(flag == 0){
                if(type == 'attach'){
                    props.setToastMessage(`Collection attached to ${props.groupAttachment[0]} ${props.groupAttachment[0] !== 'All Devices' ? 'group' : ''} successfully.`);
                    
                    props.setAllAttachmentGrp((prev: any) => [...prev.slice(1)]);
                }else if(type == 'detach'){
                    props.setToastMessage(`Collection detached from ${props.groupDetachment[0]} ${props.groupDetachment[0] !== 'All Devices' ? 'group' : ''} successfully.`);

                    props.setAllDetachmentGrp((prev: any) => [...prev.slice(1)]);
                } 

                // props.setToastMessage("Automation attached to selected devices successfully.");
                props.setmessagebar1(false);
                props.setmessagebar2(true);

                // setTimeout(() => {
                //     navigate("/manage/devices/remediation");
                // }, 5000);
            }
        }
    }

    const insertValueOfComponent = async (valu: String, revl: any, varnameuniq: any, varscopuniq: any, varuniq: any, mgroupuniq: any ) => {
        const lastchange: any = Math.floor(Date.now() / 1000);

        const { data } = await client.mutate({
          mutation: insertValueOfComponentQuery,
          variables: {valu, revl, varnameuniq, varscopuniq, varuniq, mcatuniq, mgroupuniq, lastchange}
        });
    
        if(data.insert_core_VarValues.affected_rows > 0){
            console.log("new component value inserted");
            return true;
        }else{
            return false;
        }
    };

    const deleteValueOfComponents = async (id: any) => {
        const { data } = await client.mutate({
            mutation: deleteValueOfComponentQuery,
            variables: { id }
        });
        
        if(data.delete_core_VarValues.affected_rows > 0){
            console.log("component value deleted");
            return true;
        }else{
            return false;
        }
    };

    const updateValueOfComponent = async (valu: String, revl: any, varnameuniq: any, varscopuniq: any, varuniq: any, mgroupuniq: any, valueid: any) => {
        console.log("valueid=",valueid);
        const lastchange: any = Math.floor(Date.now() / 1000);

        const { data } = await client.mutate({
            mutation: insertValueOfComponentQuery,
            variables: {valu, revl, varnameuniq, varscopuniq, varuniq, mcatuniq, mgroupuniq, lastchange}
        });
        
        if(data.insert_core_VarValues.affected_rows > 0){
            console.log("new component value inserted");
            return true;
        }else{
            return false;
        }
    };

    const updateValueOfComponents = async (whereCondition: any, valu: String, revl: any) => {
        const lastchange: any = Math.floor(Date.now() / 1000);

        const { data } = await client.mutate({
          mutation: updateValueOfComponentQuery,
          variables: {whereCondition, valu, revl, lastchange}
        });
    
        if(data.update_core_VarValues.affected_rows > 0){
            console.log("component value updated");
            return true;
        }else{
            return false;
        }
    };

    const attachRemediation = async () => {
        var selected = contextValue.selectedRowIdInTable;
        var selectedGroups = props.groupAttachment.filter((val: any) => val != 'All Devices');

        if(selected.includes('All Devices')){
            selctedValue = 'tenant';
            await getGroupIdOfTenant({name: {_eq: tenantName}}, 'attach');
        }
        
        if(selectedGroups.length > 0){
            selctedValue = 'deviceClassification'; 
            await getGroupIdOfTenant({name: {_in: selectedGroups}}, 'attach');
        }
    };

    const detachRemediation = () => {
        var selectedGroups = props.groupDetachment.filter((val: any) => val != 'All Devices');

        if(props.groupDetachment.includes('All Devices')){
            selctedValue = 'tenant';
            getGroupIdOfTenant({name: {_eq: tenantName}}, 'detach');
        }
        
        if(selectedGroups.length > 0){
            selctedValue = 'deviceClassification';
            getGroupIdOfTenant({name: {_in: selectedGroups}}, 'detach');
        }
    };
  
    const modifyRemediation = async () => {
        console.log("automationID=",automationID);
        

        await getAutomationList({id: {_in: [automationID]},  types: {_eq: "app policy"}}, null, null);

        if(props.groupDetachment.length > 0){
            detachRemediation();
        }else if(props.groupAttachment.length > 0){
            attachRemediation();
        }
    }
  
    useEffect(() => {   
        modifyRemediation();
    },[props.saveBtnClicked, props.groupAttachment, props.groupDetachment]);

    return (
        <></>
    )
}

export { Conditional_Accesses_Attach_func }